<template>
  <section>
    <b-card>
      <template #header>
        <div class="d-flex align-items-center">
          <span class="text-primary">Preventivi </span>
          <b-breadcrumb class="ml-2">
            <b-breadcrumb-item>
              <feather-icon
                icon="HomeIcon"
                scale="1.25"
                shift-v="1.25"
              ></feather-icon>
            </b-breadcrumb-item>
            <b-breadcrumb-item active> Elenco Preventivi</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </template>

      <div class="mt-2">
        <b-table :fields="fields" :items="estimates" responsive show-empty> 
          <template #empty>
            <h5 class="text-center my-2 text-primary-light">Non ci sono preventivi</h5>
          </template>
        </b-table>
      </div>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BBreadcrumb,
  BBreadcrumbItem,
  BTable,
} from "bootstrap-vue";

import { Requests } from "@/api";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BBreadcrumb,
    BBreadcrumbItem,
    BTable,
  },

  data: () => ({
    fields: [
      {
        key: "id_preventivo",
        sortable: true,
      },
      {
        key: "data_preventivo",
        sortable: true,
      },
      {
        key: "nome_venditore",
        sortable: true,
      },
      {
        key: "nome_cliente",
        sortable: true,
      },
      {
        key: "marca",
        sortable: true,
      },
      {
        key: "modello",
        sortable: true,
      },
      {
        key: "targa",
        sortable: true,
      },
      {
        key: "opzioni",
        sortable: false,
      },
    ],

    estimates: [],

    //Helpers

    loading: false,
  }),

  created() {
    this.getEstimateList();
  },  

  methods: {
    async getEstimateList() {
      this.loading = true;

      try {
        const response = await Requests.getEstimatesList();
        this.estimates = response;
      } catch(err) {
        console.debug(err)
      }

      this.loading = false;
    },
  },
};
</script>
